// extracted by mini-css-extract-plugin
export var button = "contact-us-box-module--button--6fe10";
export var buttonsWrapper = "contact-us-box-module--buttonsWrapper--fdf1a";
export var container = "contact-us-box-module--container--65fb2";
export var header = "contact-us-box-module--header--fc092";
export var hidden = "contact-us-box-module--hidden--33d5a";
export var phoneNumber = "contact-us-box-module--phoneNumber--3cb4c";